/* import __COLOCATED_TEMPLATE__ from './messenger-security.hbs'; */
/* RESPONSIBLE TEAM: team-app-security */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type IntlService from 'ember-intl/services/intl';
import type Store from '@ember-data/store';
import { get } from 'embercom/lib/ajax';

interface Signature {
  Element: HTMLDivElement;
  Args: {};
}
interface PingDomainResponse {
  domain: string;
  successful_last_request: boolean;
  errors_count: number;
}

export default class MessengerSecurity extends Component<Signature> {
  @service declare intl: IntlService;
  @service declare appService: any;
  @service declare store: Store;
  @service declare intercomEventService: any;

  @tracked pingDomains: Record<string, PingDomainResponse[]> = {
    web: [],
    ios: [],
    android: [],
  };
  @tracked webHasErrors = false;
  @tracked iosHasErrors = false;
  @tracked androidHasErrors = false;

  constructor(owner: unknown, args: Signature['Args']) {
    super(owner, args);
    this.loadPingDomains();
  }

  async loadPingDomains() {
    let platforms: Array<'web' | 'ios' | 'android'> = ['web', 'ios', 'android'];
    for (let platform of platforms) {
      try {
        let idvResponse = await get('/ember/ping_domain_errors/list', {
          app_id: this.appService.app.id,
          type: 'idv',
          platform,
        });
        let idvPingDomains = idvResponse.items;
        let jwtResponse = await get('/ember/ping_domain_errors/list', {
          app_id: this.appService.app.id,
          type: 'jwt',
          platform,
        });
        let jwtPingDomains = jwtResponse.items;
        this.pingDomains[platform] = [...idvPingDomains, ...jwtPingDomains];
        if (platform === 'web') {
          this.webHasErrors = this.pingDomains.web.some(
            (domain: PingDomainResponse) => domain.successful_last_request === false,
          );
        } else if (platform === 'ios') {
          this.iosHasErrors = this.pingDomains.ios.some(
            (domain: PingDomainResponse) => domain.successful_last_request === false,
          );
        } else if (platform === 'android') {
          this.androidHasErrors = this.pingDomains.android.some(
            (domain: PingDomainResponse) => domain.successful_last_request === false,
          );
        }
      } catch (error) {
        console.error('Failed to load ping domains for platform', error);
      }
    }
  }

  get webIdentityVerified() {
    return this.appService.app.identityVerified;
  }

  get iosIdentityVerified() {
    return this.iosSdkApp?.identityVerified;
  }

  get androidIdentityVerified() {
    return this.androidSdkApp?.identityVerified;
  }

  get iosSdkApp() {
    return this.appService.app.iosSdkApps?.firstObject;
  }

  get androidSdkApp() {
    return this.appService.app.androidSdkApps?.firstObject;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Workspace::Security::Tabs::MessengerSecurity': typeof MessengerSecurity;
  }
}
